import { CarrierLoader } from './CarrierLoader';

export const carriersLoader: { (token?: string): CarrierLoader } = (token) =>
  new CarrierLoader(token);
